// Date 2021-01-04 16:47:07

import repairConstructionUnit from "@/store/em/repair/RepairConstructionUnitStore.js";
import repairSpecializedType from "@/store/em/repair/RepairSpecializedTypeStore.js";
import repairPlanDetail from "@/store/em/repair/RepairPlanDetailStore.js";
import repairEventLevel from "@/store/em/repair/RepairEventLevelStore.js";
import repairOrigin from "@/store/em/repair/RepairOriginStore.js";
import repairPlanCategory from "@/store/em/repair/RepairPlanCategoryStore.js";
import repairPriority from "@/store/em/repair/RepairPriorityStore.js";
import repairWorkOrder from "@/store/em/repair/RepairWorkOrderStore.js";
import repairPlan from "@/store/em/repair/RepairPlanStore.js";
import repairSppOrder from "@/store/em/repair/RepairSppOrderStore.js";

const genericEntities = [
    'repairConstructionUnit',
    'repairSpecializedType',
    'repairPlanDetail',
    'repairEventLevel',
    'repairOrigin',
    'repairPlanCategory',
    'repairPriority',
    'repairWorkOrder',
    'repairPlan',
    'repairSppOrder'

]

const entities = {
    repairConstructionUnit,
    repairSpecializedType,
    repairPlanDetail,
    repairEventLevel,
    repairOrigin,
    repairPlanCategory,
    repairPriority,
    repairWorkOrder,
    repairPlan,
    repairSppOrder

}

export {genericEntities}

export default entities